<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                          <img src="@/assets/images/e-tjx-qqgb-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>全球机场贵宾厅服务</h3>
                        <p>您可在全球百余个国家的机场贵宾厅、国内十余家高铁贵宾候车室尊享贵宾厅礼遇,让您拋开大厅的喧嚣,忘却航班延误的苦恼,轻松等候,尽享尊贵。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>钛金鑫卡持卡人,全年无限次享贵宾厅服务,每次可携带3名亲友一起入内。不得转让、转借他人。</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则3</p>
                <p>您在抵达本行签约的贵宾休息室接待处后,出示二维码(关注本行信用卡微信公众号,点击“用卡权益—权益平台—全球机场贵宾厅服务—立即使用”)出现二维码页面,展示给前场工作人员即可核对消费单据并签名,即可进入休息室享受服务。</p>
                <p class="bold">细则4</p>
                <p>本行签约的贵宾休息室具体位置、服务设施及使用规定，具体以上海农商银行APP展示为准。</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>